import axios from 'axios'
import { uuidv4 } from '/@/utils/uuid'
import { CURRENT_CONFIG } from './config'
import { message } from 'ant-design-vue'
import router from '/@/router'
import { ELocalStorageKey, ERouterName, EUserType } from '/@/types/enums'
import JSONbig from 'json-bigint'// 解决精度问题
export * from './type'

const REQUEST_ID = 'X-Request-Id'
function getAuthToken () {
  return localStorage.getItem(ELocalStorageKey.Token)
}

axios.defaults.transformResponse = [function (data:any) {
  const json = JSONbig({
    storeAsString: true,
  })
  const res = json.parse(data)
  return res
}]
const instance = axios.create({
  // withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
  baseURL: CURRENT_CONFIG.baseURL,
  // timeout: 12000,
})

instance.interceptors.request.use(
  config => {
    config.headers[ELocalStorageKey.Token] = getAuthToken()
    return config
  },
  error => {
    return Promise.reject(error)
  },
)

instance.interceptors.response.use(
  response => {
    if (response.data.code && response.data.code !== 0) {
      // 销毁所有现有消息 显示下一个提示时关闭上一个提示
      message.destroy()
      message.error(response.data.message)
      if (response.data.code === 401) {
        const flag: number = Number(localStorage.getItem(ELocalStorageKey.Flag))
        switch (flag) {
          case EUserType.Web:
            router.push(ERouterName.PROJECT)
            break
          case EUserType.Pilot:
            router.push(ERouterName.PILOT)
            break
          default:
            router.push(ERouterName.PROJECT)
            break
        }
      }
      return Promise.reject(response.data)
    }
    return response
  },
  err => {
    const requestId = err?.config?.headers && err?.config?.headers[REQUEST_ID]
    if (requestId) {
      console.info(REQUEST_ID, '：', requestId)
    }
    console.info('url: ', err?.config?.url, `【${err?.config?.method}】 \n>>>> err: `, err)

    let description = '-'
    if (err.response?.data && err.response.data.message) {
      description = err.response.data.message
    }
    if (err.response?.data && err.response.data.result) {
      description = err.response.data.result.message
    }
    // @See: https://github.com/axios/axios/issues/383
    if (!err.response || !err.response.status) {
      const flag: number = Number(localStorage.getItem(ELocalStorageKey.Flag))
      switch (flag) {
        case EUserType.Web:
          router.push(ERouterName.PROJECT)
          break
        case EUserType.Pilot:
          router.push(ERouterName.PILOT)
          break
        default:
          router.push(ERouterName.PROJECT)
          break
      }
      return
    }
    if (err.response?.status !== 200) {
      if (err.response?.status === 401) {
        const flag: number = Number(localStorage.getItem(ELocalStorageKey.Flag))
        switch (flag) {
          case EUserType.Web:
            router.push(ERouterName.PROJECT)
            break
          case EUserType.Pilot:
            router.push(ERouterName.PILOT)
            break
          default:
            router.push(ERouterName.PROJECT)
            break
        }
      } else {
        message.error(`ERROR_CODE: ${err.response?.status}`)
      }
    }
    return Promise.reject(err)
  },
)

export default instance
